import { SupportedLocale, Translation } from './constants';

export const loadTranslationAsync = async (language: string, namespace: string) => {
  const loader = LooseLanguageLoaders[language]?.[namespace];

  if (!loader) throw new Error(`Unknown language/namespace: ${language}/${namespace}`);

  return loader();
};

const LanguageLoaders: Record<SupportedLocale, Record<string, Loader>> = {
  en: {},
  cimode: {},
};

const LooseLanguageLoaders: Record<string, Record<string, Loader>> = LanguageLoaders;

type Loader = () => Promise<Translation>;
